import React from 'react';

interface ContractorDetailsProps {
  onNavigate: (screen: string) => void;
}

const ContractorDetails: React.FC<ContractorDetailsProps> = ({ onNavigate }) => {
  // Get contractor info from localStorage or props
  const contractorName = 'Elite Roofing Solutions'; // This would come from the bid data
  const contractorInfo = {
    name: contractorName,
    rating: 4.9,
    reviews: 127,
    description: 'Specializes in residential roofing • 15+ years experience',
    licenseNumber: 'TN-123456',
    insurance: 'Fully Insured',
    warranty: '25-year materials, 5-year labor',
    timeline: '5-7 days',
    paymentTerms: '50% upfront, 50% upon completion',
    startDate: 'Available next week',
    specialties: ['Residential Roofing', 'Shingle Installation', 'Roof Repairs', 'Gutter Installation'],
    certifications: ['GAF Certified', 'CertainTeed Certified', 'BBB A+ Rating'],
    serviceAreas: ['Nashville', 'Franklin', 'Brentwood', 'Murfreesboro']
  };

  return (
    <div className="container">
      {/* Header */}
      <div className="header" style={{ background: '#123c3b', color: 'white', padding: '20px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
          <div className="logo" style={{ fontSize: 24, fontWeight: 600, letterSpacing: -0.5, cursor: 'pointer' }} onClick={() => onNavigate('landing')}>CoreBids</div>
          
          {/* Back Button */}
          <button
            onClick={() => onNavigate('contractor-bids')}
            style={{
              background: '#2563eb',
              border: 'none',
              color: 'white',
              fontSize: '14px',
              fontWeight: '500',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#1d4ed8';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#2563eb';
            }}
          >
            ← Back to Bids
          </button>
        </div>
      </div>

      <div className="content">
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: '40px 20px' }}>
          
          {/* Contractor Header */}
          <div className="dashboard-card" style={{ marginBottom: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 24 }}>
              <div>
                <h1 style={{ fontSize: 32, fontWeight: 700, color: '#111827', margin: '0 0 8px 0' }}>
                  {contractorInfo.name}
                </h1>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ fontSize: 20, fontWeight: 600, color: '#111827' }}>
                      {contractorInfo.rating}★
                    </span>
                    <span style={{ color: '#6b7280', fontSize: 14 }}>
                      ({contractorInfo.reviews} reviews)
                    </span>
                  </div>
                  <span style={{ 
                    background: '#10b981', 
                    color: 'white', 
                    padding: '4px 8px', 
                    borderRadius: '4px', 
                    fontSize: '12px', 
                    fontWeight: '600' 
                  }}>
                    Licensed & Insured
                  </span>
                </div>
                <p style={{ color: '#6b7280', fontSize: 16, margin: 0 }}>
                  {contractorInfo.description}
                </p>
              </div>
            </div>
          </div>

          {/* Company Information */}
          <div className="dashboard-card" style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827', margin: '0 0 20px 0' }}>
              Company Information
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 20 }}>
              <div>
                <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>License Number</div>
                <div style={{ color: '#111827', fontSize: 16, fontWeight: '500' }}>{contractorInfo.licenseNumber}</div>
              </div>
              <div>
                <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>Insurance Status</div>
                <div style={{ color: '#111827', fontSize: 16, fontWeight: '500' }}>{contractorInfo.insurance}</div>
              </div>
              <div>
                <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>Warranty</div>
                <div style={{ color: '#111827', fontSize: 16, fontWeight: '500' }}>{contractorInfo.warranty}</div>
              </div>
              <div>
                <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>Timeline</div>
                <div style={{ color: '#111827', fontSize: 16, fontWeight: '500' }}>{contractorInfo.timeline}</div>
              </div>
            </div>
          </div>

          {/* Services & Specialties */}
          <div className="dashboard-card" style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827', margin: '0 0 20px 0' }}>
              Services & Specialties
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
              {contractorInfo.specialties.map((specialty, index) => (
                <div key={index} style={{
                  background: '#f3f4f6',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: '#374151',
                  fontWeight: '500'
                }}>
                  {specialty}
                </div>
              ))}
            </div>
          </div>

          {/* Certifications */}
          <div className="dashboard-card" style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827', margin: '0 0 20px 0' }}>
              Certifications & Awards
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
              {contractorInfo.certifications.map((cert, index) => (
                <div key={index} style={{
                  background: '#ecfdf5',
                  border: '1px solid #d1fae5',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: '#065f46',
                  fontWeight: '500'
                }}>
                  {cert}
                </div>
              ))}
            </div>
          </div>

          {/* Service Areas */}
          <div className="dashboard-card" style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827', margin: '0 0 20px 0' }}>
              Service Areas
            </h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {contractorInfo.serviceAreas.map((area, index) => (
                <span key={index} style={{
                  background: '#dbeafe',
                  color: '#1e40af',
                  padding: '6px 12px',
                  borderRadius: '20px',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  {area}
                </span>
              ))}
            </div>
          </div>

          {/* Payment Terms */}
          <div className="dashboard-card" style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827', margin: '0 0 20px 0' }}>
              Payment Terms & Timeline
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 20 }}>
              <div>
                <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>Payment Terms</div>
                <div style={{ color: '#111827', fontSize: 16, fontWeight: '500' }}>{contractorInfo.paymentTerms}</div>
              </div>
              <div>
                <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>Earliest Start Date</div>
                <div style={{ color: '#111827', fontSize: 16, fontWeight: '500' }}>{contractorInfo.startDate}</div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 40 }}>
            <button
              onClick={() => onNavigate('contractor-bids')}
              style={{
                padding: '12px 24px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                background: 'white',
                color: '#374151',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#2563eb';
                e.currentTarget.style.color = '#2563eb';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#d1d5db';
                e.currentTarget.style.color = '#374151';
              }}
            >
              Back to Bids
            </button>
            <button
              onClick={() => onNavigate('contractor-bids')}
              style={{
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                background: '#10b981',
                color: 'white',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#059669';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#10b981';
              }}
            >
              Accept This Bid
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContractorDetails;
